import React from 'react';
import PropTypes from 'prop-types';
import './GuaranteePanel.css';

const GuaranteePanel = ({ children }) => {
  return (
    <div className='guarantee-panel'>
      <div className='guarantee-panel-container'>{children}</div>
    </div>
  );
};

GuaranteePanel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuaranteePanel;
